import { useState, useCallback } from 'react';
import { PerformanceHistoryRange } from '@shared/types';
import { useAccountHistory, type PerformanceHistoryAnchor } from '../../queries/retailAccounts';

export type { PerformanceHistoryAnchor };

export const usePortfolioHistory = (
  accountId: string | null,
  anchor?: PerformanceHistoryAnchor,
  contentReady = false,
) => {
  const [selectedRange, setSelectedRange] = useState<PerformanceHistoryRange>('ALL');

  const { data: history, isFetching: loading, error } = useAccountHistory(
    accountId,
    selectedRange,
    anchor,
    contentReady,
  );

  const errorMessage = error
    ? ((error as { response?: { data?: { error?: string } } }).response?.data?.error ??
      'Failed to load performance history')
    : null;

  const selectRange = useCallback((range: PerformanceHistoryRange) => {
    setSelectedRange(range);
  }, []);

  return {
    selectedRange,
    history,
    loading,
    error: errorMessage,
    selectRange,
  };
};
